import React from 'react'

interface CardProps {
  children: React.ReactNode
  className?: string
}

const Card = ({ children, className = '' }: CardProps) => (
  <div className={`bg-white rounded-[10px] shadow-xl ${className}`}>
    {children}
  </div>
)

export default Card
